import Provider from "../../../common/providers/new/provider";
import Form from "../models/form";
import {Constructor} from "../../../global/constructor";
import {HTTPMethod} from "../../../common/providers/new/httpMethod";
import {IProviderRoutes} from "../../../common/interfaces/provider";
import {IFormComparatorResponse, IServerData} from "../../../common/interfaces/serverInterfaces";
import {IDiffPayload, IMergePayload} from "../../../common/interfaces/mergeInterfaces";

interface IFormProviderRoutes {
  backUp: string;
  loadFormsAvailable: string;
  merge: string;
  publish: string;
  unpublish: string;
  requestPublish: string;
  requestUnpublish: string;
  cancelRequest: string;
  revert: string;
  diff: string;
}

export default class FormProvider<T extends Form = Form> extends Provider<T> {
  routes: IProviderRoutes & IFormProviderRoutes;

  constructor(protected modelType: Constructor<T>, public modelRoot: string, public collectionRoot: string) {
    super(modelType, modelRoot, collectionRoot);
    let newRoutes: IFormProviderRoutes = {
      backUp: `${this.endPointBase}/:id/back_up`,
      loadFormsAvailable: `organizations/:organization_id/search_all_shared_forms`,
      merge: `${this.endPointBase}/:id/merge`,
      publish: `${this.endPointBase}/:id/publish`,
      unpublish: `${this.endPointBase}/:id/unpublish`,
      requestPublish: `${this.endPointBase}/:id/request_publish`,
      requestUnpublish: `${this.endPointBase}/:id/request_unpublish`,
      cancelRequest: `${this.endPointBase}/:id/cancel_request`,
      // approveRequest: `${this.endPointBase}/:id/approve_request`, // post
      // rejectRequest: `${this.endPointBase}/:id/reject_request`,
      revert: `${this.endPointBase}/:id/revert`,
      diff: `${this.endPointBase}/:id/diff`,
    };
    Object.assign(this.routes, newRoutes);
  }

  backUp(obj: T, objJson?: object): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.backUp.replace(':id', obj.id),
        method: HTTPMethod.PUT,
        json: {[this.modelRoot]: objJson || obj.asJson()}
      }).then(resolve);
    });
  }

  loadFormsAvailable(organization_id: string): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.loadFormsAvailable.replace(':organization_id', organization_id)
      }).then(resolve);
    });
  }

  merge(obj: T, payload: IMergePayload): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.merge.replace(':id', obj.id),
        method: HTTPMethod.POST,
        json: payload,
      }).then(resolve);
    });
  }

  publish(obj: T, objJson?: object): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.publish.replace(':id', obj.id),
        method: HTTPMethod.POST,
        json: {[this.modelRoot]: objJson || obj.asJson()}
      }).then(resolve);
    });
  }


  unpublish(obj: T): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.unpublish.replace(':id', obj.id),
        method: HTTPMethod.PUT
      }).then(resolve);
    });
  }


  requestPublish(obj: T): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.requestPublish.replace(':id', obj.id),
        method: HTTPMethod.PUT
      }).then(resolve);
    });
  }

  requestUnpublish(obj: T): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.requestUnpublish.replace(':id', obj.id),
        method: HTTPMethod.PUT
      }).then(resolve);
    });
  }

  cancelRequest(obj: T): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.cancelRequest.replace(':id', obj.id),
        method: HTTPMethod.PUT
      }).then(resolve);
    });
  }

  revertToSnapshot(obj: T, snapshotId: string, objJson?: object): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.revert.replace(':id', obj.id),
        method: HTTPMethod.PUT,
        json: {snapshot_id: snapshotId, [this.modelRoot]: objJson}
      }).then(resolve);
    });
  }

  diff(obj: T, payload: IDiffPayload): Promise<IServerData<IFormComparatorResponse>> {
    return new Promise<IServerData<IFormComparatorResponse>>((resolve, reject) => {
      this.serverAction<IFormComparatorResponse>({
        endpoint: this.routes.diff.replace(':id', obj.id),
        method: HTTPMethod.GET,
        json: payload,
      }).then(resolve);
    })
  }
}